import perCapitaRankings from "../metrics/sortedby_bands_per_capita.json";
import totalBandsRankings from "../metrics/sortedby_total_bands.json";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import {
  Box,
  FormControl,
  IconButton,
  InputAdornment,
  List,
  MenuItem,
  Select,
  styled,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const StyledTextField = styled(TextField)({
  "& label.MuiInputLabel-root": {
    color: "#8f90bc",
  },
  "& label.Mui-unfocused": {
    color: "#8f90bc",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#8f90bc",
  },
  "& .MuiInputBase-input": {
    color: "#8f90bc",
  },
  "& .MuiInputAdornment-root": {
    color: "white",
  },
  "& .MuiInputAdornment-focused": {
    color: "white",
  },
});

const StyledList = styled(List)({
  borderTop: "1px solid #8f90bc",
  width: "100%",
  minHeight: "calc(100vh - 180px)",
  maxHeight: "calc(100vh - 180px)",
  height: "100%",
  overflowY: "scroll",
  "&::-webkit-scrollbar": {
    width: "1em",
  },
  "&::-webkit-scrollbar-track": {
    boxShadow: "inset 0 0 6px #8f90bcaa",
    webkitBoxShadow: "inset 0 0 6px #8f90bcaa",
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#8f90bc20",
  },
});

export default function Rankings({ mapRef, isMapLoaded }) {
  const [filter, setFilter] = useState("");
  const [metric, setMetric] = useState("bandsPerCapita");
  const [isCollapsed, setIsCollapsed] = useState(false);
  const isMobile = useMediaQuery("(max-width:599px)");

  const handleChangeMetric = (e) => {
    if (e.target.value === "totalBands" && metric !== "totalBands") {
      setMetric(e.target.value);
    } else if (metric !== "bandsPerCapita" && metric !== "bandsPerCapita") {
      setMetric(e.target.value);
    }
  };

  const renderRow = (ranking, index) => {
    if (
      !filter.length ||
      (filter.length &&
        ranking.country.toLowerCase().includes(filter.toLowerCase()))
    ) {
      return (
        <ListItem
          key={ranking.alpha3}
          component="div"
          disablePadding
          sx={{ height: "fitContent" }}
        >
          <ListItemButton
            onClick={() => {
              mapRef.setViewState({
                longitude: ranking.longitude,
                latitude: ranking.latitude,
                zoom: 4,
              });

              if (isMobile) {
                setIsCollapsed(true);
              }

              // mapRef.setFilter({
              //   id: "country-filter",
              //   field: "ISO_A3",
              //   value: [ranking.alpha3],
              // });
            }}
          >
            <ListItemText
              disableTypography
              primary={
                <Box
                  sx={{
                    display: "flex",
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="h6" sx={{ color: "#8f90bc" }}>
                    #{index + 1}
                  </Typography>
                  <img
                    style={{ marginLeft: "10px" }}
                    loading="lazy"
                    width="20"
                    src={`https://flagcdn.com/w20/${ranking.alpha2.toLowerCase()}.png`}
                    srcSet={`https://flagcdn.com/w40/${ranking.alpha2.toLowerCase()}.png 2x`}
                    alt={`Flag of ${ranking.country}`}
                  />
                  <Typography
                    variant="h6"
                    sx={{ color: "#8f90bc", marginLeft: "10px" }}
                  >
                    {ranking.country}
                  </Typography>
                </Box>
              }
              secondary={
                <Typography variant="body1" sx={{ color: "#8f90bcaa" }}>
                  {metric === "totalBands"
                    ? `${ranking.totalBands.toLocaleString("en-US")} bands`
                    : `${ranking.bandsPer100kPeople.toPrecision(
                        4
                      )} bands per 100k people`}
                </Typography>
              }
            />
          </ListItemButton>
        </ListItem>
      );
    }
    return null;
  };

  return isMapLoaded && perCapitaRankings && totalBandsRankings ? (
    isCollapsed ? (
      <>
        <IconButton
          onClick={() => setIsCollapsed(false)}
          sx={{
            "&:hover": {
              backgroundColor: "#0f1119",
            },
            cursor: "pointer",
            width: "120px",
            height: "80px",
            position: "absolute",
            margin: "10px",
            backgroundColor: "#0f1119",
            zIndex: 100,
            borderRadius: "8px",
            padding: "10px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          <Typography sx={{ color: "white" }}>Rankings</Typography>
          <ChevronRightIcon
            sx={{ color: "white", height: "30px", width: "30px" }}
          />
        </IconButton>
      </>
    ) : (
      <Box
        id="rankings"
        style={{
          width: isMobile ? "100vw" : "25vw",
          minWidth: isMobile ? "200px" : "400px",
          maxWidth: isMobile ? "95vw" : "100vw",
          maxHeight: isMobile ? "100%" : "100vh",
          height: isMobile ? "100%" : "calc(100vh - 40px)",
          position: "absolute",
          margin: 0,
          backgroundColor: "#0f1119",
          zIndex: 100,
          padding: isMobile ? "10px" : "20px",
        }}
      >
        <IconButton
          onClick={() => setIsCollapsed(true)}
          sx={{
            cursor: "pointer",
            position: "absolute",
            top: 5,
            right: 5,
          }}
        >
          <ChevronLeftIcon
            sx={{ color: "#8f90bc", height: "40px", width: "40px" }}
          />
        </IconButton>
        <Typography
          variant="h4"
          style={{
            color: "white",
          }}
        >
          Most Metal Countries
        </Typography>
        <FormControl variant="standard">
          <Select
            sx={{
              "& .MuiInputBase-input": {
                color: "#8f90bc",
              },
              "&:before": {
                borderColor: "#8f90bc",
              },
              "&:after": {
                borderColor: "#8f90bc",
              },
              "&:not(.Mui-disabled):hover::before": {
                borderColor: "#8f90bc",
              },
            }}
            labelId="select-metric-label"
            id="select-metric"
            value={metric}
            onChange={handleChangeMetric}
            MenuProps={{
              PaperProps: {
                sx: {
                  bgcolor: "#0f1119",
                  "& .MuiMenuItem-root": {
                    color: "#8f90bc",
                  },
                },
              },
            }}
          >
            <MenuItem value={"bandsPerCapita"}>by bands per capita</MenuItem>
            <MenuItem value={"totalBands"}>by total bands</MenuItem>
          </Select>
        </FormControl>
        <StyledTextField
          id="outlined-search"
          label="Search countries"
          variant="standard"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "white" }} />
              </InputAdornment>
            ),
          }}
          sx={{ width: "100%", marginTop: "10px" }}
          onChange={(e) => setFilter(e.currentTarget.value)}
        />
        <StyledList>
          {metric === "totalBands"
            ? totalBandsRankings.map((ranking, index) =>
                renderRow(ranking, index)
              )
            : perCapitaRankings.map((ranking, index) =>
                renderRow(ranking, index)
              )}
        </StyledList>
      </Box>
    )
  ) : null;
}
